import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import PublicLayout from "@/components/PublicLayout";
import Home from "@/pages/Home";
import Compare from "@/pages/Compare";
import ProductPage from "@/pages/ProductPage";
import Checkout from "@/pages/Checkout";
import ThankYou from "@/pages/ThankYou";
import Legal from "@/pages/Legal";
import AdminLogin from "@/pages/admin/Login";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import Orders from "@/pages/admin/Orders";
import OrderDetail from "@/pages/admin/OrderDetail";
import Products from "@/pages/admin/Products";
import Promos from "@/pages/admin/Promos";
import SettingsPage from "@/pages/admin/SettingsPage";
import Tournees from "@/pages/admin/Tournees";
import ManualOrder from "@/pages/admin/ManualOrder";
import Traffic from "@/pages/admin/Traffic";
import Gallery from "@/pages/admin/Gallery";

function App() {
  return (
    <AuthProvider>
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/comparatif" element={<Compare />} />
            <Route path="/gamme/:gammeKey" element={<ProductPage />} />
            <Route path="/commander" element={<Checkout />} />
            <Route path="/merci" element={<ThankYou />} />
            <Route path="/cgv" element={<Legal type="cgv" />} />
            <Route path="/mentions-legales" element={<Legal type="mentions" />} />
          </Route>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="commandes" element={<Orders />} />
            <Route path="commandes/:orderId" element={<OrderDetail />} />
            <Route path="produits" element={<Products />} />
            <Route path="galerie" element={<Gallery />} />
            <Route path="promos" element={<Promos />} />
            <Route path="parametres" element={<SettingsPage />} />
            <Route path="tournees" element={<Tournees />} />
            <Route path="nouvelle-commande" element={<ManualOrder />} />
            <Route path="trafic" element={<Traffic />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
